import { stripWorkerReadOnlyProfilePatchFields } from './profileWorkerReadOnlyFields';

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}

/**
 * PATCH /profile accepts flat fields only (Nest whitelist). Nested `private_client`
 * causes HTTP 400 even when occupation/birth_date are valid at the top level.
 */
export function sanitizeProfilePatchBody(body: Record<string, unknown>): Record<string, unknown> {
  let out = body;
  if (isPlainObject(body.private_client)) {
    const { private_client: _nested, ...rest } = body;
    out = rest;
  }
  return stripWorkerReadOnlyProfilePatchFields(out);
}
